module.exports = __webpack_public_path__ + "media/icons/offer-details-ilosc-miejsc-8c6acb69.png";